import { Chip } from "@artprov/design-system";
import { useMatchingJudicialFiltersStore } from "../zustand/filters.store.js";
import { useFilterOptions } from "../hooks/useFilterOptions.js";
import { formatNumberToArgentino } from "../../../common/utils/functions/numberUtils.js";

export default function TagsFilters() {
    const { fechaAltaDesde, fechaAltaHasta, fechaDebitoDesde, fechaDebitoHasta, coincidenciaDesde, coincidenciaHasta, jurisdiccion } = useMatchingJudicialFiltersStore((state) => state.filters);
    const clearFilter = useMatchingJudicialFiltersStore((state) => state.clearFilter);

    // Cargar opciones de filtros (jurisdicciones) desde hook centralizado
    const { getJurisdiccionLabel } = useFilterOptions();

    // Construir objeto de filtros aplicados
    const appliedFilters = {};
    if (fechaAltaDesde) appliedFilters.fechaAltaDesde = fechaAltaDesde;
    if (fechaAltaHasta) appliedFilters.fechaAltaHasta = fechaAltaHasta;
    if (fechaDebitoDesde) appliedFilters.fechaDebitoDesde = fechaDebitoDesde;
    if (fechaDebitoHasta) appliedFilters.fechaDebitoHasta = fechaDebitoHasta;
    if (coincidenciaDesde !== null && coincidenciaDesde !== undefined) appliedFilters.coincidenciaDesde = coincidenciaDesde;
    if (coincidenciaHasta !== null && coincidenciaHasta !== undefined) appliedFilters.coincidenciaHasta = coincidenciaHasta;
    if (jurisdiccion) appliedFilters.jurisdiccion = jurisdiccion;

    const entries = Object.entries(appliedFilters).filter(([, value]) => value !== null && value !== undefined && value !== "");

    if (!entries.length) return null;

    const filterLabels = {
        fechaAltaDesde: "Alta desde",
        fechaAltaHasta: "Alta hasta",
        fechaDebitoDesde: "Débito desde",
        fechaDebitoHasta: "Débito hasta",
        coincidenciaDesde: "Coincidencia desde",
        coincidenciaHasta: "Coincidencia hasta",
        jurisdiccion: "Jurisdicción",
    };

    const handleRemove = (key) => {
        clearFilter(key);
    };

    const getLabelForFilter = (key, value) => {
        const label = filterLabels[key];

        // Formatear fechas
        if (key === "fechaAltaDesde" || key === "fechaAltaHasta" || key === "fechaDebitoDesde" || key === "fechaDebitoHasta") {
            const [year, month, day] = value.split('-');
            const formattedDate = `${day}/${month}/${year}`;
            return `${label}: ${formattedDate}`;
        }

        // Formatear porcentajes (convertir punto a coma)
        if (key === "coincidenciaDesde" || key === "coincidenciaHasta") {
            const formattedPercent = formatNumberToArgentino(value);
            return `${label}: ${formattedPercent}%`;
        }

        // Convertir ID de jurisdicción a nombre
        if (key === "jurisdiccion") {
            return `${label}: ${getJurisdiccionLabel(value)}`;
        }

        return `${label}: ${value}`;
    };

    return (
        <div className="flex flex-wrap gap-2">
            {entries.map(([key, value]) => (
                <Chip
                    key={`chip-${key}`}
                    label={getLabelForFilter(key, value)}
                    variant="primary"
                    onClose={() => handleRemove(key)}
                />
            ))}
        </div>
    );
}
